'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fLabel$002ejs from "@ui5/webcomponents/dist/Label.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024 from "./com.raquo.laminar.codecs.package$.js";
import * as $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent from "./io.github.nguyenyou.ui5.webcomponents.laminar.shared.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$() {
  this.dz = null;
  this.cu = null;
  this.dV = null;
  this.dW = false;
  this.I3 = null;
  this.I4 = false;
  this.I5 = null;
  this.I6 = false;
  $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent__T__(this, "ui5-label");
}
export { $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$ as $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$ };
$p = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$.prototype = new $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$;
/** @constructor */
function $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$() {
}
export { $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$ as $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$ };
$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$.prototype = $p;
$p.y2 = (function() {
  if ((!this.I4)) {
    this.I3 = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "required", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().gN));
    this.I4 = true;
  }
  return this.I3;
});
$p.Cw = (function() {
  if ((!this.I6)) {
    this.I5 = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "show-colon", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().gN));
    this.I6 = true;
  }
  return this.I5;
});
$p.cQ = (function() {
  return $i_$0040ui5$002fwebcomponents$002fdist$002fLabel$002ejs.default;
});
var $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$, "io.github.nguyenyou.ui5.webcomponents.laminar.Label$", ({
  jD: 1,
  ac: 1
}));
export { $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$ as $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$ };
var $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$;
function $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$() {
  if ((!$n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$)) {
    $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$ = new $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$();
  }
  return $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$;
}
export { $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$ as $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Label$ };
